








































import { Component, Vue } from 'vue-property-decorator'

type PortalNavigationLinks = {
  [key: string]: string
}

@Component
class PortalNavigationMenu extends Vue {
  get portalLink() {
    return process.env.VUE_APP_PORTAL_LINK
  }

  portalLinks: PortalNavigationLinks = {
    capabilities: `${this.portalLink}capabilities/`,
    partners: `${this.portalLink}partners/`,
    cityBonus: `${this.portalLink}city_bonus/`,
    news: `${this.portalLink}news/`,
    support: `${this.portalLink}support/`,
  }
}

export default PortalNavigationMenu
